export default {"src":"/_next/static/media/AI-enabled-digital-assistants.eb258bf3.svg","height":75,"width":90,"blurWidth":0,"blurHeight":0};